import Form from "../../componets/Form";

export default function Section8() {
  return (
    <div className="container-1280 py-6 xl:min-w-[70%] lg:min-w-[90%] w-[95%] pb-10 m-auto flex flex-col items-center lg:flex-row justify-evenly">
      <div className="lg:w-[45%] w-[90%] flex flex-col justify-evenly gap-5 lg:gap-4 pb-10 lg:pb-0 " >
        <h2 className="self-start text-3xl font-bold">Contact Us</h2>
        <p>Innovative Web Solutions for Your Success.</p>
        <p>
          Mean3 utilizes the information you provide to share relevant content,
          products, and services tailored to your interests. You can unsubscribe
          from these communications at any time. For further details, please
          refer to our Privacy Policy.
        </p>
        <img src="../../../../assets/contactUsForm-image.png" alt="" />
      </div>

      <div className="lg:w-[50%] w-[90%]">
        <div className="md:min-h-[500px] h-auto flex flex-col justify-around pt-4 pb-4 ">
          <h2 className="text-[#ea2339] xl:text-3xl text-3xl font-semibold md:font-bold pl-1.5 mb-3">
            We'd Love to Speak to You !
          </h2>
          <Form />
        </div>
      </div>
    </div>
  );
}
